import React, { useEffect } from "react";
import EmploymentContainer from "./WGV/EmploymentContainer";
import CompanyInformationContainer from "./WGV/CompanyInformationContainer";
import DebtorIncomeContainer from "./WGV/DebtorIncomeContainer";
import OccupationsContainer from "./WGV/OccupationsContainer";
import PersonalInformationContainer from "./WGV/PersonalInformationContainer";
import { useInFormation } from "../Context/InFormationContext";
import FormRenderer from "../organisms/FormRenderer";
const WGVFormContainer = (props) => {
    const { setInFormation } = useInFormation();
    useEffect(() => {
        setInFormation({
            title: "Loonvordering ex art. 19 Invorderingswet",
        });
    }, []);
    const steps = [
        {
            component: EmploymentContainer,
            url: "/dienstverband",
        },
        {
            component: CompanyInformationContainer,
            url: "/bedrijfsgegevens",
            title: "Bedrijfsgegevens",
            stepIndex: 1,
        },
        {
            component: DebtorIncomeContainer,
            url: "/inkomsten-schuldenaar",
            title: "Inkomsten schuldenaar",
            stepIndex: 2,
        },
        {
            component: OccupationsContainer,
            url: "/beslagen-zorginstituut-en-eigen-verrekening",
            title: "Beslagen",
            stepIndex: 3,
        },
        {
            component: PersonalInformationContainer,
            url: "/uw-gegevens",
            title: "Uw gegevens",
            stepIndex: 4,
        },
    ];
    return React.createElement(FormRenderer, Object.assign({ formCode: "WGV", steps: steps }, props));
};
export default WGVFormContainer;
